module.exports = __webpack_public_path__ + "img/shake_btn.f02f2fa7.png";